/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import MainContainer from "../../../layout/MainContainer";
import { Button, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import {
  getFromStorage,
  removeFromStorage,
  STORAGE_KEYS,
} from "../../../helpers";
import { OfferData } from "../../../types/General";
import dayjs from "dayjs";
import {
  useCreateOfferMutation,
  useUpdateOfferMutation,
} from "../../../service/offer";
import { showError, showToast } from "../../../constants/toasts";
import Loader from "../../../constants/Loader";
import {
  formatDubaiDate,
  formatDubaiDateTime,
  formatDubaiTime,
} from "../../../utils/dateTime";
import { OFFER_TYPE } from "../../../utils/enums";

function PreviewOffer() {
  const location = useLocation();
  const { state } = location;
  const updateId = state?.updateId || "";
  const isClone = state?.isClone || "";
  const categoryTab = state?.categoryTab || "";
  const status = state?.status || "";
  const categoryName = state?.categoryName || "";
  const categoryId = state?.categoryId;

  const [createOffer] = useCreateOfferMutation();
  const [updateOffer] = useUpdateOfferMutation();
  const searchParams = new URLSearchParams(location.search);
  const offerData = getFromStorage(STORAGE_KEYS.offerData);
  const parsedData: OfferData | null = offerData
    ? (JSON.parse(offerData) as OfferData)
    : null;

  const mode = searchParams.get("mode");
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const [loading, setLoading] = useState(false);

  // Merge date with time
  const mergeDateAndTime = (date: string, time: string) => {
    if (!date || !time) return null;
    const datePart = dayjs(date).format("YYYY-MM-DD"); // from updated date
    const timePart = dayjs(time).format("HH:mm:ss"); // from old time
    return dayjs(`${datePart}T${timePart}`).toISOString();
  };

  const createOfferApi = async () => {
    const formData = new FormData();

    const appendIfPresent = (key: string, value: any) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    };

    const appendArray = (key: string, arr?: any[]) => {
      if (Array.isArray(arr)) {
        arr.forEach((item) => {
          if (item !== undefined && item !== null && item !== "") {
            formData.append(key, item);
          }
        });
      }
    };

    appendIfPresent("Title", parsedData?.Title);
    appendIfPresent("Badge", parsedData?.Badge);
    appendIfPresent("Description", parsedData?.Description);
    appendIfPresent("Subtitle", parsedData?.Subtitle);
    appendIfPresent("CategoryId", parsedData?.CategoryId);
    appendIfPresent("OfferType", parsedData?.OfferType);

    appendIfPresent(
      "EventDateTime",
      parsedData?.EventTime ?
        mergeDateAndTime(
          parsedData?.EventDateTime,
          parsedData?.EventTime
        )
        : null
    );

    appendIfPresent(
      "EventTime",
      parsedData?.EventTime
        ? dayjs(parsedData?.EventTime).format("HH:mm:ss")
        : null
    );

    appendIfPresent(
      "DealerDate",
      parsedData?.DealerTime
        ? mergeDateAndTime(
          parsedData?.DealerDate,
          parsedData?.DealerTime
        )
        : null
    );

    appendIfPresent(
      "DealerTime",
      parsedData?.DealerTime
        ? dayjs(parsedData?.DealerTime).format("HH:mm:ss")
        : null
    );

    appendIfPresent(
      "OfferDisplayStartDate",
      parsedData?.OfferDisplayStartDate
        ? mergeDateAndTime(
          parsedData?.OfferDisplayStartDate,
          parsedData?.OfferDisplayTime
        )
        : null
    );

    appendIfPresent(
      "OfferDisplayEndDate",
      parsedData?.OfferDisplayEndDate
        ? mergeDateAndTime(
          parsedData?.OfferDisplayEndDate,
          parsedData?.OfferDisplayEndTime
        )
        : null
    );

    appendIfPresent(
      "IsButterflyEffect",
      parsedData?.IsButterflyEffect ? "true" : "false"
    );

    appendIfPresent(
      "ButterflyEffectStartDate",
      parsedData?.ButterflyEffectStartDate
        ? mergeDateAndTime(
          parsedData?.ButterflyEffectStartDate,
          parsedData?.ButterflyEffectStartTime
        )
        : null
    );

    appendIfPresent(
      "ButterflyEffectEndDate", // fixed the duplicate key name
      parsedData?.ButterflyEffecteEndDate
        ? mergeDateAndTime(
          parsedData?.ButterflyEffecteEndDate,
          parsedData?.ButterflyEffectEndTime
        )
        : null
    );

    appendIfPresent("ButtonName", parsedData?.ButtonName);
    appendArray("GroupsId", parsedData?.GroupsId);
    appendArray("TagsId", parsedData?.TagsId);
    appendArray("offerImages", parsedData?.offerImages);
    appendIfPresent("AdvanceBookingPeriod", parsedData?.AdvanceBookingPeriod);
    appendIfPresent(
      "IsCancellationPolicy",
      parsedData?.IsCancellationPolicy ? "true" : "false"
    );
    appendIfPresent(
      "CancellationAmountPerPerson",
      parsedData?.CancellationAmountPerPerson
    );

    appendIfPresent("CancellationHours", parsedData?.CancellationHours);

    appendIfPresent(
      "QuestionJson",
      JSON.stringify(parsedData?.QuestionJson || [])
    );

    appendIfPresent(
      "OfferDisplayTime",
      parsedData?.OfferDisplayTime
        ? dayjs(parsedData?.OfferDisplayTime).format("HH:mm:ss")
        : null
    );

    appendIfPresent(
      "OfferDisplayEndTime",
      parsedData?.OfferDisplayEndTime
        ? dayjs(parsedData?.OfferDisplayEndTime).format("HH:mm:ss")
        : null
    );

    appendIfPresent(
      "ButterflyEffectStartTime",
      parsedData?.ButterflyEffectStartTime
        ? dayjs(parsedData?.ButterflyEffectStartTime).format("HH:mm:ss")
        : null
    );
    appendIfPresent(
      "ButterflyEffectEndTime",
      parsedData?.ButterflyEffectEndTime
        ? dayjs(parsedData?.ButterflyEffectEndTime).format("HH:mm:ss")
        : null
    );
    appendIfPresent(
      "SpecificOfferStartDate",
      parsedData?.SpecificOfferTime
        ? mergeDateAndTime(
          parsedData?.SpecificOfferStartDate,
          parsedData?.SpecificOfferTime
        )
        : null
    );
    appendIfPresent("IsActive", "true");
    appendIfPresent("IsArchive", "false");
    appendIfPresent("IsGuestAdded", parsedData?.IsGuestAdded ? "true" : null);
    appendIfPresent("NumberOfGuest", parsedData?.NumberOfGuest);
    appendIfPresent("NoMemberPrice", parsedData?.NoMemberPrice);
    appendIfPresent("MaxCapacity", parsedData?.MaxCapacity);
    appendIfPresent("ThresholdCapacity", parsedData?.ThresholdCapacity);
    appendIfPresent("EventType", parsedData?.EventType);
    appendIfPresent("MemberPrice", parsedData?.MemberPrice);
    appendIfPresent("WhatsAppNumber", parsedData?.WhatsAppNumber);
    appendIfPresent("CountryDialCode", parsedData?.CountryDialCode);
    appendIfPresent("IsSpecificDateTime", parsedData?.IsSpecificDateTime);
    appendIfPresent("IsAdvanceBooking", parsedData?.IsAdvanceBooking);
    appendIfPresent("OfferId", updateId);
    appendIfPresent("IsdiningforOther", parsedData?.IsdiningforOther);

    if (!updateId || isClone) {
      try {
        setLoading(true);
        const response = await createOffer(formData).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          removeFromStorage(STORAGE_KEYS.offerData);
          // navigate("/manage-offer/preview-offer-detail");
          showToast(response?.message || "");
          navigate("/manage-offer", {
            state: { status, categoryTab, categoryId, categoryName },
          });
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    } else {
      try {
        setLoading(true);
        const response = await updateOffer(formData).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          removeFromStorage(STORAGE_KEYS.offerData);
          // navigate("/manage-offer/preview-offer-detail");
          showToast(response?.message || "");
          navigate("/manage-offer", {
            state: { status, categoryTab, categoryId, categoryName },
          });
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    }
  };

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Preview Offer
            </h1>
          </div>
          <div style={{ display: "flex", gap: 20 }}>
            <div className="btn_flex flx_end">
              <Button className="btn btn_primary" onClick={createOfferApi}>
                Submit
              </Button>
            </div>
            <div>
              <Button className="btn btn_primary" onClick={goBack}>
                Edit
              </Button>
            </div>
          </div>
        </div>
        <div className="cards  view_page prvw_ofr">
          <h2>Image Upload</h2>
          <ul className="imgs_mn">
            {parsedData?.offerImages?.map((item: any) => (
              <li>
                <figure>
                  <img src={item} alt="icon" />
                </figure>
              </li>
            ))}
          </ul>
          <span className="tag">{parsedData?.SelectedCategoryName || "-"}</span>
          <h2>{parsedData?.OfferType || "-"}</h2>
          <div className="rstrnt_flx">
            <div className="rstrnt_lst">
              <p>Title</p>
              <h3>{parsedData?.Title || "-"}</h3>
            </div>
            <div className="rstrnt_lst">
              <p>Location</p>
              <h3>{parsedData?.Badge || "-"}</h3>
            </div>
            <div className="rstrnt_lst">
              <p>Subtitle</p>
              <h3>{parsedData?.Subtitle || "-"}</h3>
            </div>

            {mode?.toUpperCase() === "EVENTS" ? null : (
              <div className="rstrnt_lst">
                <p>Groups</p>
                <h3>{parsedData?.groupNames?.slice().join(" & ")}</h3>
              </div>
            )}

            {mode?.toUpperCase() === "EVENTS" ? null : (
              <div className="rstrnt_lst">
                <p>Tag</p>
                <h3>{parsedData?.tagNames?.slice().join(" & ")}</h3>
              </div>
            )}

            <div className="rstrnt_lst">
              <p>Offer Display Start Period</p>
              <h3>
                {parsedData?.OfferDisplayStartDate
                  ? formatDubaiDateTime(
                    mergeDateAndTime(
                      parsedData?.OfferDisplayStartDate,
                      parsedData?.OfferDisplayTime
                    )
                  )
                  : "-"}
              </h3>
            </div>
            <div className="rstrnt_lst">
              <p>Offer Display End Period</p>
              <h3>
                {" "}
                {parsedData?.OfferDisplayEndDate
                  ? formatDubaiDateTime(
                    mergeDateAndTime(
                      parsedData?.OfferDisplayEndDate,
                      parsedData?.OfferDisplayEndTime
                    )
                  )
                  : "-"}
              </h3>
            </div>
            <div className="rstrnt_lst">
              <p>Advance Booking Period</p>
              <h3>{parsedData?.AdvanceBookingPeriod || "-"}</h3>
            </div>
          </div>
          {parsedData?.OfferType === OFFER_TYPE.CONTACT_DEALERS ? (
            <>
              <div className="rstrnt_flx mt_30">
                <div className="rstrnt_lst">
                  <p>End Date </p>
                  <h3>
                    {" "}
                    {parsedData?.DealerDate
                      ? formatDubaiDate(parsedData?.DealerDate)
                      : "-"}
                  </h3>
                </div>
                <div className="rstrnt_lst">
                  <p>End Time </p>
                  <h3>
                    {parsedData?.DealerTime
                      ? formatDubaiTime(parsedData?.DealerTime)
                      : "-"}
                  </h3>
                </div>
                <div className="rstrnt_lst">
                  <p>Whats App Number </p>
                  <h3>{`+${parsedData?.CountryDialCode || ""} ${parsedData?.WhatsAppNumber || "-"}`}</h3>
                </div>
              </div>
            </>
          ) : parsedData?.OfferType === OFFER_TYPE.EVENTS ? (
            <>
              <div className="rstrnt_flx mt_30">
                <div className="rstrnt_lst">
                  <p>Event Date </p>
                  <h3>
                    {" "}
                    {parsedData?.EventDateTime
                      ? formatDubaiDate(parsedData?.EventDateTime)
                      : "-"}
                  </h3>
                </div>
                <div className="rstrnt_lst">
                  <p>Event Time </p>
                  <h3>
                    {parsedData?.EventTime
                      ? formatDubaiTime(parsedData?.EventTime)
                      : "-"}
                  </h3>
                </div>
              </div>
            </>
          ) : parsedData?.OfferType === OFFER_TYPE.OTHERS ? (
            <>
              {parsedData?.IsSpecificDateTime ? (
                <div className="rstrnt_flx mt_30">
                  <div className="rstrnt_lst">
                    <p>End Date </p>
                    <h3>
                      {parsedData?.SpecificOfferStartDate
                        ? formatDubaiDate(parsedData?.SpecificOfferStartDate)
                        : "-"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>End Time </p>
                    <h3>
                      {parsedData?.SpecificOfferTime
                        ? formatDubaiTime(parsedData?.SpecificOfferTime)
                        : "-"}
                    </h3>
                  </div>
                </div>
              ) : null}
            </>
          ) : null}

          <div className="btrfly_eft_mn">
            <div className="btrfly_eft_lft">
              <div className="btrfly_eft control_group w_50">
                <label>Butterfly Effect</label>
                <IosSwitchMain
                  checked={parsedData?.IsButterflyEffect ? true : false}
                  disabled={true}
                />
              </div>
              {
                parsedData?.IsButterflyEffect ? <div className="rstrnt_flx" style={{ marginBottom: "30px" }}>
                  <div className="rstrnt_lst">
                    <p>Butterfly Effect Start Date </p>
                    <h3>
                      {parsedData?.ButterflyEffectStartDate
                        ? formatDubaiDate(parsedData?.ButterflyEffectStartTime)
                        : "-"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Butterfly Effect Start Time </p>
                    <h3>
                      {parsedData?.ButterflyEffectStartTime
                        ? formatDubaiTime(parsedData?.ButterflyEffectStartTime)
                        : "-"}
                    </h3>
                  </div>

                  <div className="rstrnt_lst">
                    <p>Butterfly Effect End Date </p>
                    <h3>
                      {parsedData?.ButterflyEffecteEndDate
                        ? formatDubaiDate(parsedData?.ButterflyEffectEndTime)
                        : "-"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Butterfly Effect End Time </p>
                    <h3>
                      {parsedData?.ButterflyEffectEndTime
                        ? formatDubaiTime(parsedData?.ButterflyEffectEndTime)
                        : "-"}
                    </h3>
                  </div>
                </div> : null
              }


              <div className="effts_dscrptn">
                <p>Description</p>
                {parsedData?.Description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: parsedData?.Description,
                    }}
                  />
                ) : (
                  <p>-</p>
                )}
              </div>
              {parsedData?.IsCancellationPolicy ? (
                <div className="cncltn_plcy">
                  <h2>Cancellation Policy</h2>
                  <div className="effts_dscrptn">
                    <p>Cancellation Amount</p>
                    <h3>{`${parsedData?.CancellationAmountPerPerson || "-"} AED`}</h3>
                  </div>
                  <div className="effts_dscrptn">
                    <p>Cancellation Hours</p>
                    <h3>{`${parsedData?.CancellationHours || "-"} Hours`}</h3>
                  </div>
                </div>
              ) : null}
            </div>
            {parsedData?.IsButterflyEffect ? (
              <div className="btrfly_eft_ryt">
                <figure>
                  <img src={parsedData?.offerImages[0] || ""} alt="" />
                </figure>
                <div className="btrfly_eft_rytcnt">
                  <span>{parsedData?.SelectedCategoryName || "-"}</span>
                  <h3>{parsedData?.Title || "-"}</h3>
                  <p>{parsedData?.Subtitle || "-"}</p>
                </div>
              </div>
            ) : null}
          </div>

          <div className="control_group w_100 prfrnc">
            {parsedData?.QuestionJson?.length ? (
              <div style={{ marginTop: "10px" }}>
                <h2 style={{ marginBottom: "20px" }}>Saved Questions</h2>
                {parsedData?.QuestionJson?.map((q: any, idx) => (
                  <div key={idx} style={{ marginBottom: 10 }}>
                    <strong
                      style={{ fontSize: "16px" }}
                    >{`${idx + 1}. ${q?.question || q?.label}`}</strong>{" "}
                    ({q.inputType})
                    {(q.inputType === "checkbox" ||
                      q.inputType === "radio" ||
                      q.inputType === "Checkbox" ||
                      q.inputType === "Radio") && (
                        <ul className="options_list">
                          {q?.options?.map((opt: any, i: any) => {
                            return (
                              <li
                                style={{
                                  marginLeft: 30,
                                  marginTop: 5,
                                  color: "white",
                                }}
                                key={i}
                                className="option_item"
                              >
                                {opt?.optionText}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </MainContainer>
    </>
  );
}

export default PreviewOffer;
